import React, { useEffect, useRef, useState } from "react";
import { useFrame, useThree } from "@react-three/fiber";

import { TextureLoader } from "three";
import { v } from "../../env/env_variable";




function Star(props) {


	// args:
    const radius = props.radius
    const meshRef = useRef(null);


    // Load the texture to planet:
    const textureLoader = new TextureLoader();
    const texture = textureLoader.load(require(`${props.data.textures.base}`));

	  // const texture = textureLoader.load(require('../assets/texture/sun.jpg'));

    useFrame((state, delta) => (meshRef.current.rotation.y += 0.001));

    const { camera } = useThree();
    useEffect(() => {
        const currentPosition = camera.position;

    }, [camera])


    
    return (
      <group>
        <mesh {...props} ref={meshRef}>
          <sphereGeometry args={[radius/v.scale, 100]} />
          <meshStandardMaterial  map={texture} emissive={'orange'} emissiveIntensity={0.5}/>
        </mesh>
        {props.children}
      </group>
    );
};

export default Star

